<template>
  <transition name="slide-top">
    <div class="flex flex-col items-center absolute pin-t mt-14 w-full mx-auto z-1010">
      <div class="flex flex-row justify-center text-center w-64 p-2 rounded bg-white italic" v-html="message"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'notification',
  props: {
    message: String
  },
  computed: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>
</style>
